module.exports = __webpack_public_path__ + "static/media/google-map-logo.d26b4846.png";